<script setup lang="ts">
import { computed } from 'vue'
import { NMessageProvider } from 'naive-ui'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { useDesign } from '@/hooks/web/useDesign'
import { ElNotification } from 'element-plus'
import { useUserStore } from './store/modules/user'

const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()

const userStore = useUserStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

appStore.initTheme()
userStore.initDomain()
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <NMessageProvider>
      <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
    </NMessageProvider>
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{adminNamespace}-app';

.size {
  width: 100%;
  height: 100%;
}
.ph_font {
  font-family: Alibaba PuHuiTi 3;
}

.btnKp {
  background: linear-gradient(to right, #ff9330, #f27328);
  color: #ffffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.cursor-pointer {
  cursor: pointer;
}

:root {
  --el-color-primary: green;
  --course-borderno: #e7ebf5;
  --course-border: #ff9330;
}

html,
body {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
  }
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
</style>
